let changeWallpaperImage = (state, { payload }) => {
    state.wallpaperImage = payload;
};

export default changeWallpaperImage;
